export const loginUserSaga = 'LOGIN_USER_SAGA';
export const logoutUserSaga = 'LOGOUT_USER_SAGA';
export const getAuthUserInfoSaga = 'GET_AUTH_USER_INFO_SAGA';
export const receiveAuthUserInfo = 'RECEIVE_AUTH_USER_INFO';
export const receiveProfileInfo = 'RECEIVE_PROFILE_INFO';
export const setHasCheckedUserInfo = 'SET_HAS_CHECKED_USER_INFO';
export const setIsSaving = 'SET_IS_SAVING';
export const updateAuthUserInfoSaga = 'UPDATE_AUTH_USER_INFO_SAGA';
export const cancelAutoRenewalSubscriptionSaga = 'CANCEL_AUTO_RENEWAL_SUBSCRIPTION_SAGA';